import { db } from "@/firebase/firebaseInit";
import { collection, doc, getDocs, setDoc, updateDoc } from "firebase/firestore";

export default {
    async loadEvents(context) {
        const querySnapshot = await getDocs(collection(db, "events"));

        const events = [];

        querySnapshot.forEach((doc) => {
            console.log(doc.id, " => ", doc.data());
            var event = doc.data();
            event.id = doc.id;
            events.push(event);
        });

        context.commit('setEvents', events);
    },

    async loadRegistrationList(context, payload) {
        console.log("Loading registrations for event: ", payload);
        const registered = [];
        try {
            const querySnapshot = await getDocs(collection(db, "events/" + String(payload) + "/registrations"));
            querySnapshot.forEach((doc) => {
                var docData = doc.data();
                docData.id = doc.id;
                registered.push(docData);
                console.log("Register: ", doc.data());
            });
        } catch (error) {
            console.error(error);
            throw error;
        }
        console.log("Register List: ", registered);
        context.commit('setRegistrationList', registered);
    },

    async registerBeneficiaryForEvent(context, payload) {
        console.log("Registering beneficiary: " + payload.beneficiaryID + " for event: " + payload.eventID);
        await setDoc(doc(db, "events/" + payload.eventID + "/registrations", String(payload.beneficiaryID)+"_"+payload.note.trim()), {
            beneficiaryID: payload.beneficiaryID,
            name: payload.name,
            note: payload.note,
            yearOfBirth: payload.yearOfBirth,
            gender: payload.gender
        });
    },

    async updateNote(context, payload) {
        const registrationRef = doc(db, "events/" + String(payload.eventID) + "/registrations/" + String(payload.beneficiaryID));
        await updateDoc(registrationRef, {
            note: payload.note
        }); 
    }
}